import React from "react";
import { Tooltip } from "@mui/material";

export default function citationToolTip({ content }) {
  const extractHTMLAndMarkdown = (stringValue, limitString = true) => {
    if (stringValue.length > 0) {
      const replacedString = stringValue
        .replace(/(<([^>]+)>)/gi, "")
        .replace(/#/g, "")
        .replace(/☐/g, "")
        .replace(/^([.\s])+/, "");

      if (limitString) return replacedString.substring(0, 120) + "...";

      return replacedString;
    }

    return "Unable to display citation result. Please click citation to view full result.";
  };

  return (
    <Tooltip
      title={extractHTMLAndMarkdown(content, false)}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "black",
            color: "white",
            fontSize: "1.1rem",
            width: "100%",
            maxWidth: "30vw",
            whiteSpace: "pre-line",
            boxSizing: "border-box",
            maxHeight: "40vh",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          },
        },
      }}
    >
      {extractHTMLAndMarkdown(content)}
    </Tooltip>
  );
}
